import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网剧迷都在讨论的热门话题，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-500/30 hover:bg-primary-500/5 transition-all duration-300 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {topic.tag}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}